import { SelectionType } from "../../../../data";
export function getBetBtnModifier(selection, type) {
    const betBtnModifier = `rj-superbanner__bet-button UniqueOdd_${selection.sbtechId}_${type === SelectionType.QA ? 1 : 0}`;
    if (selection.isSelected) {
        return `${betBtnModifier} rj-superbanner__bet-button--selected chosenBet`;
    }
    return betBtnModifier;
}
//# sourceMappingURL=getBetBtnModifier.js.map